<template>
  <div class="question-wrapper w-100">
    <h5 class="my-2">{{ question.text }}</h5>

    <ul v-for="(choice, index) in question.choices" :key="index">
      <li v-if="choice.length">
        {{ choice }}
        <CProgress
            :max="question.totalCount === 0 ? 100 : question.totalCount"
            :value="choiceCount(index)"
            class="w-100 mt-2"
            showPercentage
        />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
    },
  },
  methods: {
    choiceCount(index) {
      let choiceCount = "";
      switch (index) {
        case 0:
          choiceCount = this.question.choice1Count;
          break;
        case 1:
          choiceCount = this.question.choice2Count;
          break;
        case 2:
          choiceCount = this.question.choice3Count;
          break;
        case 3:
          choiceCount = this.question.choice4Count;
          break;
        case 4:
          choiceCount = this.question.choice5Count;
          break;
        case 5:
          choiceCount = this.question.choice6Count;
          break;
      }
      return choiceCount;
    },
  },
};
</script>

<style lang="scss">
.question-wrapper {
  border-bottom: 1px solid #d8dbe0;
  padding: 8px 0;

  &:last-child {
    border-bottom: none;
  }
}
</style>